module.exports = __webpack_public_path__ + "img/7.26467850.png";